import React from 'react';
import { services } from '../data/mock';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import * as Icons from 'lucide-react';
import { ExternalLink } from 'lucide-react';

const Services = () => {
  const bgColor = '#ffffff';
  const textColor = '#1a2332';
  const accentColor = '#d4af37';

  return (
    <section id="services" className="py-20" style={{ backgroundColor: bgColor, color: textColor }}>
      <div className="container mx-auto px-6">
        <div className="mb-16 text-center">
          <h2 className="mb-4 font-serif text-4xl font-bold md:text-5xl">Services Offered</h2>
          <div className="mx-auto h-1 w-24 rounded" style={{ backgroundColor: accentColor }}></div>
          <p className="mx-auto mt-6 max-w-3xl text-lg opacity-90">
            Comprehensive solutions from talent acquisition consulting to custom software development
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => {
            const IconComponent = Icons[service.icon] || Icons.Briefcase;
            return (
              <Card
                key={service.id}
                className="group border-none shadow-lg transition-all hover:scale-[1.02]"
              >
                <CardHeader>
                  <div
                    className="mb-4 inline-flex rounded-full p-4 transition-all group-hover:scale-110"
                    style={{ backgroundColor: `${accentColor}20` }}
                  >
                    <IconComponent className="h-8 w-8" style={{ color: accentColor }} />
                  </div>
                  <CardTitle className="font-serif text-2xl font-bold">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="mb-6 leading-relaxed opacity-90">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex gap-3">
                        <span
                          className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full"
                          style={{ backgroundColor: accentColor }}
                        ></span>
                        <span className="text-sm opacity-90">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  {service.link && (
                    <a
                      href={service.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-4 inline-flex items-center gap-2 font-medium transition-all hover:underline"
                      style={{ color: accentColor }}
                    >
                      Visit Platform
                      <ExternalLink className="h-4 w-4" />
                    </a>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
